import SectionWrapper from '@/common/SectionWrapper';
import VehicleCarousel from '@/common/VehicleCarousel';
import { CarouselTileWrapper } from '@/common/VehicleCarousel/CarouselTileWrapper';
import LoadingVehicleCarousel from '@/common/VehicleCarousel/LoadingVehicleCarousel';
import VehicleTile from '@/srp/VehicleTile';
import useGetSrpSuggestedForYou from '~/hooks/srp/services/useGetSrpSuggestedForYou';
import useGetSrpVehicleAvailability from '~/hooks/srp/services/useGetSrpVehicleAvailability';

export default function SuggestedForYouCarousel() {
  const { hasError, isLoaded, vehicles } = useGetSrpSuggestedForYou();

  useGetSrpVehicleAvailability(vehicles);

  if (!isLoaded) {
    return (
      <LoadingVehicleCarousel
        hasBottomBorder
        hasGutterPadding={false}
        tileCount={3}
      />
    );
  }

  if (hasError || vehicles.length === 0) return null;

  return (
    <SectionWrapper
      analyticsSection="Suggested For You"
      eventName="Free Text No Results Section"
      hasBackground={false}
    >
      <VehicleCarousel
        hasBottomBorder
        hasGutterPadding={false}
        headerTitle="Suggested for you"
      >
        {vehicles.map(vehicle => (
          <CarouselTileWrapper key={vehicle.vehicleId}>
            <VehicleTile
              showMoreDetailsModal={false}
              showTermsTooltip={false}
              vehicle={vehicle}
            />
          </CarouselTileWrapper>
        ))}
      </VehicleCarousel>
    </SectionWrapper>
  );
}
